import { getAuthApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    LoginRequest,
    PhoneVerifyRequest,
    TokenResponse,
} from '@/core/generated/api';
import type { AuthTokens, LoginMessage } from '../model/types';
import { refreshSession } from '@/core/api/sessionRefresh';

export type { AuthTokens, LoginMessage } from '../model/types';

/** Проверяет наличие токенов в ответе авторизации */
const requireTokens = (response: TokenResponse): AuthTokens => {
    if (!response.accessToken || !response.refreshToken) {
        throw new Error('Сервис авторизации не вернул токены');
    }

    return {
        ...response,
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
    };
};

/** Предоставляет запросы авторизации сотрудника */
export const authService = {
    /** Запрашивает код подтверждения для сотрудника */
    async login(request: LoginRequest): Promise<LoginMessage> {
        try {
            const response = await getAuthApi().apiV1AuthLoginPost({ loginRequest: request });
            const message = response.data.items?.[0];

            if (!message?.messageUuid) {
                throw new Error('Сервис авторизации не вернул идентификатор сообщения');
            }

            return {
                ...message,
                messageUuid: message.messageUuid
            };
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Подтверждает код сотрудника и возвращает токены */
    async verify(request: PhoneVerifyRequest): Promise<AuthTokens> {
        try {
            const response = await getAuthApi().apiV1AuthVerifyPost({ phoneVerifyRequest: request });

            return requireTokens(response.data);
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Обновляет токены текущей сессии */
    refresh(): Promise<AuthTokens> {
        return refreshSession();
    },
};
